<h2 mat-dialog-title>Edit Connection</h2>

<mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width mt-10">
      <mat-label>Email</mat-label>

      <mat-select formControlName="email">
        @for (email of emails; track email) {
          <mat-option [value]="email">
            {{ email }}
          </mat-option>
        }
      </mat-select>
      <mat-hint>This email will be shown in the posts</mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>
    Cancel
  </button>

  <button mat-flat-button class="lightgreen-button" type="button" (click)="updateConnection()" [disabled]="form.invalid">
    Save
  </button>
</mat-dialog-actions>